// The drag item kinds for the OET drag-and-drop (rows and columns).
const DND_TYPES = {
  ROW: 'row',
  COLUMN: 'column',
} as const;

/**
 * The drag item a column header produces. `type` discriminates it from a row
 * item so the heterogeneous drop targets (header cells, corner cell, thead,
 * rows) can ignore items of the wrong kind — the dnd-kit equivalent of the old
 * react-dnd per-type `DropTarget(DndTypes.COLUMN, ...)` / `DropTarget(ROW, ...)`
 * registration.
 */
export interface ColumnDragItem {
  type: typeof DND_TYPES.COLUMN;
  index: number;
}

/**
 * The drag item a row produces. Carries the dnd group (`'top'` or the owner
 * event id for a sub-row) and the dragged row's specialisation `level` (read by
 * drop targets to paint `highlight-level-N`).
 */
export interface RowDragItem {
  type: typeof DND_TYPES.ROW;
  index: number;
  group: string;
  level: number;
}

/** Any OET drag item (column or row). */
export type OETDragItem = ColumnDragItem | RowDragItem;

export default DND_TYPES;
